import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Container,
  TextField,
  Button,
  Card,
  CardMedia
} from '@mui/material';
import AdminLayout from './Admin_Layout/AdminLayout';
import { useLocation } from 'react-router-dom';

const AddTestimonials = () => {
  const location = useLocation();
  console.log('location state: ', location.state);
  const { update = false, formData = {} } = location.state || {}; // Retrieve state or use defaults

  const [testimonialData, setTestimonialData] = useState({
    author: '',
    title: '',
    quote: '',
    school: '',
    avatar: '',
    _id: '',
    imageFile: null,  // To store the uploaded image file
    preview: '',      // To store the image preview
    ...formData
  });

  useEffect(() => {
    if (update && formData) {
      setTestimonialData({
        ...formData,
        preview: formData.avatar || '' // Set preview from formData if avatar exists
      });
    }
  }, [update, formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTestimonialData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setTestimonialData((prev) => ({
        ...prev,
        imageFile: file,
        preview: URL.createObjectURL(file), // Set preview for image display
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(testimonialData);
    const formData = new FormData();
    formData.append("title", testimonialData.title);
    formData.append("author", testimonialData.author);
    formData.append("school", testimonialData.school);
    formData.append("quote", testimonialData.quote);
    formData.append("_id", testimonialData._id);

    if (testimonialData.imageFile) {
      formData.append("avatar", testimonialData.imageFile); // Append new image if exists
    }

    console.log("FormData entries:");
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const endpoint = update
      ? `${process.env.REACT_APP_API_URL}/api/testimonials/${testimonialData._id}`
      : `${process.env.REACT_APP_API_URL}/api/testimonials`;
    const method = update ? "PUT" : "POST";

    try {
      const response = await fetch(endpoint, {
        method,
        body: formData,
      });

      const result = await response.json();
      if (!response.ok) {
        console.log("Error details:", result);
        throw new Error(result.message || "Failed to save testimonial");
      }

      alert(update ? "Testimonial updated successfully!" : "Testimonial added successfully!");
      console.log("Saved testimonial:", result);
    } catch (error) {
      console.error("Error saving testimonial:", error);
      alert(`Error saving testimonial: ${error.message}`);
    }
  };

  return (
    <AdminLayout>
      <Box sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 8, sm: 9 } }}>
        <Container maxWidth="lg">
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: 'background.paper',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography variant="h4" gutterBottom>
              {update ? 'Update Testimonial' : 'Add New Testimonial'}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
              <Grid container spacing={3}>
                {/* Title */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Title"
                    name="title"
                    value={testimonialData.title}
                    onChange={handleInputChange}
                    placeholder="Title"
                    required
                  />
                </Grid>

                {/* Author */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Author"
                    name="author"
                    value={testimonialData.author}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>

                {/* School */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name of School"
                    name="school"
                    value={testimonialData.school}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>

                {/* Quote */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Quote"
                    name="quote"
                    value={testimonialData.quote}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>

                {/* Image Upload */}
                <Grid item xs={12}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: 'none' }}
                    id="imageUploadNew"
                  />
                  <label htmlFor="imageUploadNew">
                    <Button variant="contained" color="primary" component="span">
                      Upload Image
                    </Button>
                  </label>
                </Grid>

                {/* Image Preview */}
                <Grid item xs={12}>
                  {(testimonialData.preview || testimonialData.avatar) && (
                    <Card sx={{ maxWidth: 200, mt: 2 }}>
                      <CardMedia
                        component="img"
                        image={testimonialData.preview || testimonialData.avatar}
                        alt="Uploaded Image Preview"
                      />
                    </Card>
                  )}
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 2 }}
                  >
                    {update ? 'Update Testimonial' : 'Add Testimonial'}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </Box>
    </AdminLayout>
  );
};

export default AddTestimonials;
